module.exports = {
  'en-US': "USD",
  'es': "COP"
}
